import { Chip, Container, Grid, makeStyles } from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Form from "@saleor/components/Form";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { COUPON_COLLECTION_TYPE_CHOICES } from "@saleor/coupons/constants";
import {
  CouponCollectionErrorForm,
  CouponCollectionFormData
} from "@saleor/utils/validators/couponCollection";
import React from "react";

import CouponCollectionDetails from "../CouponCollectionDetails";
import CouponCollectionImage from "../CouponCollectionImage";
import CouponCollectionSchedule from "../CouponCollectionSchedule";

const useStyles = makeStyles(
  theme => ({
    chip: {
      marginLeft: "1em"
    },
    chipLabel: {
      fontWeight: 600
    },
    container: {
      alignItems: "stretch",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column"
      }
    },
    couponTitleChip: {
      display: "flex"
    },
    gridItem: {
      flex: 1
    },
    pageGrid: {
      display: "grid",
      gridColumnGap: "24px",
      gridRowGap: "24px",
      gridTemplateColumns: "11fr 6fr"
    },
    pageHeader: {
      display: "flex",
      justifyContent: "space-between"
    },
    previewbutton: {
      marginBottom: "15px"
    },
    requiredSymbol: {
      color: "red"
    },
    sideGrid: {
      width: "100%"
    },
    subtitle: {
      fontSize: "1rem"
    }
  }),
  { name: "CouponCollectionCreate" }
);

export interface CouponCollectionCreateProps {
  onCouponCollectionImageUpload: (file: File) => void;
  couponCollectionImage: any;
  showChip: boolean;
  errors: CouponCollectionErrorForm;
  onBack: () => void;
  onDraft(data: CouponCollectionFormData);
  onPublish(data: CouponCollectionFormData);
}

export const CouponCollectionCreate: React.FC<CouponCollectionCreateProps> = props => {
  const {
    onDraft,
    onBack,
    onPublish,
    showChip,
    errors,
    onCouponCollectionImageUpload
  } = props;
  const classes = useStyles(props);
  const initialForm: CouponCollectionFormData = {
    bannerImage: "",
    categories: [],
    classification: "",
    collectionType: COUPON_COLLECTION_TYPE_CHOICES[0].value,
    endDate: "",
    endTime: "23:59",
    id: "",
    isFeatured: false,
    isHidden: false,
    startDate: "",
    startTime: "00:00",
    status: "",
    title: "",
    writeup: null,
    slug: ""
  };

  const breadcrumbDirectory = [
    {
      name: "Coupon Collection",
      url: "/coupons/collection"
    }
  ];

  return (
    <Form initial={initialForm} onSubmit={onPublish}>
      {({ data, change, hasChanged, submit }) => (
        <Container>
          <PageBreadcrumbNavigation items={breadcrumbDirectory} />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "10px"
            }}
          >
            <PageBackNavigation onBack={onBack} />
            <PageHeader
              title={
                <>
                  <span>Create Coupon Collection </span>
                  {showChip && (
                    <Chip
                      className={classes.chipLabel}
                      label={"Editing"}
                      style={{ backgroundColor: "#FFF0BD" }}
                      icon={
                        <FiberManualRecordIcon
                          style={{
                            color: "#FFCE22"
                          }}
                        />
                      }
                    />
                  )}
                  <br />
                  <span className={classes.subtitle}>
                    Fields marked with (
                    <span className={classes.requiredSymbol}>*</span>) are
                    required.
                  </span>
                </>
              }
            />
          </div>
          <Grid container className={classes.pageGrid}>
            <div>
              <CouponCollectionDetails
                data={data}
                onChange={change}
                error={errors}
                disabled={false}
              />
              <CouponCollectionSchedule
                disabled={false}
                data={data}
                onChange={change}
                localError={errors}
              />
            </div>
            <div>
              <CouponCollectionImage
                data={data}
                onChange={change}
                errors={errors}
                onCouponCollectionImageUpload={onCouponCollectionImageUpload}
              />
            </div>
          </Grid>
          <div>
            <SaveButtonBar
              state={"default"}
              onCancel={onBack}
              onPublish={submit}
              disablePublishBtn={true}
              labels={{ cancel: "CANCEL" }}
              onDraft={() => onDraft(data)}
              disableAlternateButton={true}
              saveButtonVariant={true}
              disabled={!hasChanged}
              hideSave={true}
            />
          </div>
        </Container>
      )}
    </Form>
  );
};

export default CouponCollectionCreate;
